<template>
	<div class="chat-window">
		<div class="chat-title">
			<p>结算管理</p>
		</div>
		<div class="tips-title">结算资金已到达手机端蜘币钱包</div>
		<div style="display: flex;">
			<div style="margin: 22px 0 0 10px;">
				<el-form :inline="true">
					<el-form-item label="年月">
						<el-date-picker v-model="value2" type="month" placeholder="选择月" format="yyyy-MM" value-format='yyyy-MM'
							@change="monthChange" :picker-options="pickerOptions" >
						</el-date-picker>
					</el-form-item>
					<el-form-item label="音乐名称">
						<el-input v-model="form.musicName" placeholder="请输入音乐名称" style="width: 150px;"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="action" style="margin: auto 0;">
				<el-button size="small" type="primary"
					style="margin: 0 0 0 10px;background-color: rgba(40, 168, 207, 1);" @click="searchTable">搜索</el-button>
				<el-button size="small" @click="resetTable">重置</el-button>
			</div>
		</div>

		<div style="display: flex; margin: 10px 10px; gap: 40px; font-size: 14px;">
			<span>交易总额：<span style="font-weight: bold; color: #409EFF;">{{ musicCount.userTotal || 0 }}</span></span>
			<span>分成总额：<span style="font-weight: bold; color: #409EFF;">{{ musicCount.userTotalShare || 0 }}</span></span>
		</div>

		<div style="margin: 0 10px;">
			<el-table :data="music_list" style="width: 100%" border>
				<el-table-column label="音乐名称" align="center" prop="musicName">
				</el-table-column>
				<el-table-column label="上店时间" align="center" prop="createTime">
				</el-table-column>
				
				<el-table-column label="月交易额" align="center" prop="incomeThisMonth">
				</el-table-column>
				<el-table-column label="月分成额" align="center" prop="monthlyShare">
				</el-table-column>
				<el-table-column label="结算时间" align="center" prop="settlementTime">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import upload from "@/api/apiModel/upload"
	export default {
		data() {
			return {
				tableData: [],
				value2: '',
				value3: '',
				getKey: '',
				form: {
					month: '',
					musicName: ""
				},
				music_list: [],
				musicCount: {
					userTotal: 0,  // 用户营收总额
					userTotalShare: 0, // 用户分成总额
				},
				pickerOptions:{
					disabledDate(time) {
						const now = new Date();
						const year = time.getFullYear();
						const month = time.getMonth();
						const nowYear = now.getFullYear();
						const nowMonth = now.getMonth();
						return year > nowYear || (year === nowYear && month > nowMonth);
					}
				}
			}
		},
		mounted() {
			// 设置默认值为上个月
			this.setDefaultMonth();
			this.getList()
			this.getCount();
		},
		methods: {
			// 设置默认月份为上个月
			setDefaultMonth() {
				const now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth();
				
				// 如果当前是1月份，则上个月是去年的12月份
				if (month === 0) {
					year--;
					month = 11;
				} else {
					month--;
				}
				
				// 格式化月份，确保两位数
				const formattedMonth = (month + 1).toString().padStart(2, '0');
				const lastMonth = `${year}-${formattedMonth}`;
				
				this.value2 = lastMonth;
				this.form.month = lastMonth;
				console.log('默认月份设置为:', lastMonth);
			},
			getList() {
				upload.musicSettlementManagement(this.form).then(res => {
					console.log('音乐结算管理接口返回:', res);
					if (res && res.result) {
						const records = res.result.records || res.result;
						this.music_list = Array.isArray(records) ? records : [];
					} else {
						this.music_list = [];
					}
				}).catch(err => {
					console.error('获取结算数据失败:', err);
					this.music_list = [];
				})
			},
			// 搜索：同时调用列表和汇总接口
			searchTable() {
				this.getList();
				this.getCount();
			},
			getCount(){
				upload.musicSettlementManagementSummay(this.form).then(res => {
					// 增加空值保护，防止接口返回异常时报错
					if (res && res.result) {
						this.musicCount = res.result;
					} else {
						this.musicCount = {
							userTotal: 0,  // 用户营收总额
							userTotalShare: 0, // 用户分成总额
						};
						console.warn('结算汇总接口返回数据异常:', res);
					}
				}).catch(err => {
					console.error('获取结算汇总数据失败:', err);
					this.musicCount = {
						userTotal: 0,  // 用户营收总额
						userTotalShare: 0, // 用户分成总额
					};
				});
			},
			resetTable() {
				this.form = {
					month: '',
					musicName: ""
				}
				this.getList()
				this.getCount();
			},
			monthChange(e) {
				this.form.month = e;
				// 月份改变时更新数据和汇总
				this.getList();
				this.getCount();
			},
			
		}
	}
</script>

<style lang="less" scoped>
	.chat-window {
		min-width: 506px;
		flex: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		background: #ffffff;
		border-left: 1px solid #dcdfe6;
	}

	.chat-window .chat-title {
		display: flex;
		align-items: center;
		height: 60px;
		font-size: 18px;
		color: #313233;
		letter-spacing: 2px;
		padding: 0 20px;
		background: #ffffff;
		box-sizing: border-box;
		border-bottom: 1px solid #dcdfe6;
	}
	
	.tips-title {
		margin: 22px 0 0 10px; margin: 22px 0px 0px 10px;
		color: #00c97e;
		background: #f5f7fa;
		height: 35px;
		line-height: 35px;
		font-size: 17px;
	}

	.chat-window .chat-title p:nth-child(2) {
		font-size: 18px;
		color: #7b7d80;
		margin-left: 8px;
	}
</style>